module.exports = __webpack_public_path__ + "img/contact-colored.cf5d9149.svg";